import React, { useEffect, useState } from "react";
import { Award } from "lucide-react";
import { useParams } from "react-router-dom";
import html2canvas from "html2canvas";

import missionMaster from "../assets/badges/Mission Master.png";
import algorithmVirtuoso from "../assets/badges/Algorithm Virtuoso.png";
import interviewMaestro from "../assets/badges/Interview Maestro.png";
import problemArchitect from "../assets/badges/Problem Architect.png";
import interviewAce from "../assets/badges/interview ace.png";
import problemSolver from "../assets/badges/problem solver.png";
import codematrixstamp from "../assets/codematrix stamp.png";
import axiosClient from "../api/axiosClient";

const logo = "/codematrixLogo.png";

const badgeData = {

    "problem-solver": {
        title: "Problem Solver",
        image: problemSolver,

        description: (
            <>
                Solve 2 coding questions successfully
                <br />
                with 60% accuracy.
            </>
        )
    },

    "interview-ace": {
        title: "Interview Ace",
        image: interviewAce,

        description: (
            <>
                Master 120 questions alongside
                <br />
                15 hard core practice challenges.
            </>
        )
    },

    "problem-architect": {
        title: "Challenges Champion",
        image: problemArchitect,

        description: (
            <>
                Maintain 6 straight practice days with
                <br />
                top tier accuracy.
            </>
        )
    },

    "interview-maestro": {
        title: "Interview Maestro",
        image: interviewMaestro,

        description: (
            <>
                Complete 300 rigorous technical questions
                <br />
                and elite hard tracks.
            </>
        )
    },

    "algorithm-virtuoso": {
        title: "Problem Solving Virtuoso",
        image: algorithmVirtuoso,

        description: (
            <>
                Dominate complex algorithmic challenges
                <br />
                consistently over 8 active weeks.
            </>
        )
    },

    "mission-master": {
        title: "Master of Problem Solver",
        image: missionMaster,

        description: (
            <>
                Conquer 200 coding problems with advanced
                <br />
                high accuracy scores.
            </>
        )
    }

};

export default function CodeMatrixBadgeCertificate() {
    const { slug } = useParams();
    const currentBadge = badgeData[slug];

    const dashboardData = JSON.parse(localStorage.getItem("dashboardData")) || {};
    const badgeProgressDTO = dashboardData?.badgeProgressDTO || {};

    const badgeSlugMap = {
        "problem-solver": "problemSolver",
        "interview-ace": "interviewAce",
        "problem-architect": "challengesChampion",
        "interview-maestro": "interviewMaestro",
        "algorithm-virtuoso": "problemSolvingVirtuoso",
        "mission-master": "masterOfProblemSolver",
    };

    const currentBadgeProgress = badgeProgressDTO[badgeSlugMap[slug]];
    const isMobile = window.innerWidth <= 768;

    const [hideShareButton, setHideShareButton] = useState(false);

    const showLinkedInPopup = (onContinue) => {

        const existingPopup =
            document.getElementById("linkedin-popup");

        if (existingPopup) {
            existingPopup.remove();
        }

        const overlay = document.createElement("div");

        overlay.id = "linkedin-popup";

        overlay.innerHTML = `
    
    <div style="
        position:fixed;
        inset:0;
        background:rgba(0,0,0,0.65);
        z-index:999999;
        display:flex;
        align-items:center;
        justify-content:center;
        padding:20px;
        font-family:Inter,sans-serif;
    ">

        <div style="
            width:100%;
            max-width:520px;
            background:white;
            border-radius:28px;
            padding:35px;
            text-align:center;
            box-shadow:0 25px 80px rgba(0,0,0,0.3);
            animation:popupAnim 0.3s ease;
        ">

            <div style="
                width:85px;
                height:85px;
                margin:auto;
                border-radius:22px;
                background:linear-gradient(135deg,#7c3aed,#06b6d4);
                display:flex;
                align-items:center;
                justify-content:center;
                font-size:42px;
                color:white;
                margin-bottom:22px;
            ">
                🚀
            </div>

            <h2 style="
                margin:0;
                font-size:30px;
                color:#111827;
                font-weight:800;
            ">
                Share Certificate on LinkedIn
            </h2>

            <p style="
                margin-top:18px;
                color:#4b5563;
                font-size:16px;
                line-height:1.8;
            ">
               

                After LinkedIn opens:<br/>

⏳ Please wait few seconds for LinkedIn to load properly.<br/>

<b>Press CTRL + V</b> inside the post box<br/>
to paste your certificate instantly ✨<br/>

Then click the <b>"Post"</b> button on LinkedIn<br/>
to share your professional achievement certificate 🚀
            </p>

            <button id="continueLinkedInBtn" style="
                margin-top:28px;
                width:100%;
                border:none;
                padding:18px;
                border-radius:16px;
                background:linear-gradient(135deg,#7c3aed,#2563eb);
                color:white;
                font-size:17px;
                font-weight:700;
                cursor:pointer;
                transition:0.2s;
                box-shadow:0 12px 25px rgba(124,58,237,0.3);
            ">
                Continue to LinkedIn
            </button>


            <button id="closeLinkedInPopup" style="
    margin-top:14px;
    width:100%;
    border:none;
    padding:16px;
    border-radius:16px;
    background:#f3f4f6;
    color:#111827;
    font-size:16px;
    font-weight:700;
    cursor:pointer;
">
    Close
</button>

        </div>
    </div>
    `;

        document.body.appendChild(overlay);

        document
            .getElementById("continueLinkedInBtn")
            .onclick = () => {

                overlay.remove();

                onContinue();
            };


        document
            .getElementById("closeLinkedInPopup")
            .onclick = () => {

                overlay.remove();
            };
    };

    const shareBadgeToLinkedIn = async () => {

        showLinkedInPopup(async () => {

            try {

                const element =
                    document.getElementById("badge-card");

                if (!element) {

                    alert("Certificate not found");

                    return;
                }

                // BUTTON HIDE
                setHideShareButton(true);

                await new Promise((resolve) =>
                    setTimeout(resolve, 400)
                );

                const canvas =
                    await html2canvas(element, {
                        scale: 2,
                        useCORS: true,
                        backgroundColor: "#ffffff",
                    });

                // BUTTON WAPAS SHOW
                setHideShareButton(false);

                const blob =
                    await new Promise((resolve) =>
                        canvas.toBlob(
                            resolve,
                            "image/png"
                        )
                    );

                if (!blob) {

                    alert("Image generation failed");

                    return;
                }

                await navigator.clipboard.write([
                    new ClipboardItem({
                        "image/png": blob,
                    }),
                ]);

                // OPEN LINKEDIN
                window.open(
                    "https://www.linkedin.com/feed/?shareActive=true",
                    "_blank",
                    "width=1000,height=700"
                );

            } catch (error) {

                // AGAR ERROR AAYE TAB BHI BUTTON SHOW HO
                setHideShareButton(false);

                console.log(error);

                alert("Failed to share certificate");
            }
        });
    };


    return (
        <div style={styles.pageWrapper(isMobile)}>
            <div id="badge-card" style={styles.certificateCard(isMobile)}>
                <div style={styles.topBar}></div>
                <div style={styles.bgCircle1}></div>
                <div style={styles.bgCircle2}></div>

                <div style={styles.header(isMobile)}>
                    <div style={styles.logoSection}>
                        <div style={styles.logoBox}>
                            <img src={logo} alt="CodeMatrix Logo" style={styles.logoImage} />
                        </div>
                        <div>
                            <h2 style={styles.brandName}>CODEMATRIX</h2>
                            <p style={styles.brandTag}>Industry Ready Learning Platform</p>
                        </div>
                    </div>
                    <div style={styles.badgeMini}>
                        <Award size={18} color="#fff" />
                        <span>{currentBadge?.title}</span>
                    </div>
                </div>

                <div style={styles.mainContent(isMobile)}>
                    <div style={styles.leftSection(isMobile)}>
                        <div style={styles.smallTitle(isMobile)}>PROFESSIONAL ACHIEVEMENT BADGES</div>
                        <h1 style={styles.studentName(isMobile)}>
                            {(dashboardData?.fullName || "CodeMatrix Student").toUpperCase()}
                        </h1>
                        <div style={styles.nameUnderline(isMobile)}></div>
                        <p style={styles.description(isMobile)}>{currentBadge?.description}</p>

                        <div style={styles.statsRow(isMobile)}>
                            <div style={styles.statCard}>
                                <div style={styles.statLabel}>Issue Date</div>
                                <div style={styles.statValue}>
                                    {currentBadgeProgress?.percentage >= 100
                                        ? new Date(currentBadgeProgress?.earnedDate).toLocaleDateString("en-IN", {
                                            day: "numeric",
                                            month: "short",
                                            year: "numeric",
                                        })
                                        : "Not Earned Yet"}
                                </div>
                            </div>
                            <div style={styles.signatureBox}>
                                <img src={codematrixstamp} alt="Authority Signature" style={styles.codematrixstamp} />
                                <div style={styles.signatureLine}></div>
                                <div style={styles.signName}>CodeMatrix Authority</div>
                            </div>
                        </div>
                    </div>

                    <div style={styles.rightSection}>
                        <div style={styles.singleBadgeCard(isMobile)}>
                            <img src={currentBadge?.image} alt="CodeMatrix Badge" style={styles.singleBadgeImage} />
                            <div style={styles.badgeGlow}></div>
                        </div>
                    </div>
                </div>
                <div style={styles.footer(isMobile)}>
                    <span>© 2026 CodeMatrix By Powered</span>
                </div>

                {!hideShareButton && (
                    <div
                        style={{
                            marginTop: "28px",
                            display: "flex",
                            justifyContent: "center",
                        }}
                    >
                        <button
                            onClick={shareBadgeToLinkedIn}
                            style={{
                                border: "none",
                                padding: "18px 34px",
                                borderRadius: "18px",
                                background:
                                    "linear-gradient(135deg,#7c3aed,#2563eb)",
                                color: "#fff",
                                fontSize: "18px",
                                fontWeight: "700",
                                cursor: "pointer",
                                boxShadow:
                                    "0 12px 30px rgba(124,58,237,0.35)",
                            }}
                        >
                            Open LinkedIn Share 🚀
                        </button>
                    </div>
                )}

            </div>


        </div>

    );
}

const styles = {
    pageWrapper: (isMobile) => ({ minHeight: "100vh", background: "linear-gradient(135deg, #0f172a 0%, #111827 40%, #1e1b4b 100%)", display: "flex", alignItems: "center", justifyContent: "center", padding: isMobile ? "12px" : "40px", fontFamily: "Inter, sans-serif" }),
    certificateCard: (isMobile) => ({ width: "100%", maxWidth: "1200px", minHeight: "620px", background: "#ffffff", borderRadius: "28px", position: "relative", overflow: "hidden", boxShadow: "0 25px 80px rgba(0,0,0,0.25)", padding: isMobile ? "24px 18px 80px" : "40px 50px" }),
    topBar: { position: "absolute", top: 0, left: 0, width: "100%", height: "10px", background: "linear-gradient(90deg,#7c3aed,#06b6d4,#2563eb)" },
    bgCircle1: { position: "absolute", width: "500px", height: "500px", borderRadius: "50%", background: "rgba(124,58,237,0.05)", top: "-180px", right: "-120px" },
    bgCircle2: { position: "absolute", width: "350px", height: "350px", borderRadius: "50%", background: "rgba(6,182,212,0.05)", bottom: "-120px", left: "-100px" },
    header: (isMobile) => ({ display: "flex", flexDirection: isMobile ? "column" : "row", justifyContent: "space-between", alignItems: "center", gap: "20px", marginBottom: "40px", position: "relative", zIndex: 2 }),
    logoSection: { display: "flex", alignItems: "center", gap: "14px" },
    logoBox: { width: "58px", height: "58px", borderRadius: "18px", background: "rgba(124,58,237,0.1)", display: "flex", alignItems: "center", justifyContent: "center", border: "1px solid rgba(124,58,237,0.25)" },
    logoImage: { width: "42px", height: "42px", objectFit: "contain" },
    brandName: { margin: 0, fontSize: "28px", fontWeight: "800", letterSpacing: "2px", color: "#111827" },
    brandTag: { margin: 0, fontSize: "13px", color: "#6b7280", marginTop: "4px" },
    badgeMini: { background: "linear-gradient(135deg,#7c3aed,#4f46e5)", color: "#fff", padding: "12px 18px", borderRadius: "14px", display: "flex", alignItems: "center", gap: "10px", fontWeight: "600", boxShadow: "0 10px 30px rgba(124,58,237,0.3)" },
    mainContent: (isMobile) => ({ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "1.4fr 0.9fr", gap: isMobile ? "40px" : "20px", alignItems: "center", position: "relative", zIndex: 2 }),
    leftSection: (isMobile) => ({ paddingRight: isMobile ? "0px" : "20px", textAlign: isMobile ? "center" : "left" }),
    smallTitle: (isMobile) => ({ fontSize: isMobile ? "12px" : "14px", fontWeight: "700", color: "#7c3aed", letterSpacing: "3px", marginBottom: "24px" }),
    studentName: (isMobile) => ({ fontSize: isMobile ? "38px" : "52px", fontWeight: "800", color: "#111827", margin: 0, lineHeight: 1.1, wordBreak: "break-word" }),
    nameUnderline: (isMobile) => ({ width: "220px", height: "5px", borderRadius: "20px", background: "linear-gradient(90deg,#7c3aed,#06b6d4)", marginTop: "18px", marginBottom: "28px", marginLeft: isMobile ? "auto" : "0", marginRight: isMobile ? "auto" : "0" }),
    description: (isMobile) => ({ fontSize: isMobile ? "15px" : "17px", lineHeight: 1.9, color: "#374151", marginBottom: "18px" }),
    statsRow: (isMobile) => ({ display: "grid", gridTemplateColumns: isMobile ? "1fr" : "repeat(2,1fr)", gap: "18px", marginBottom: "34px" }),
    statCard: { background: "#f9fafb", border: "1px solid #e5e7eb", borderRadius: "18px", padding: "18px" },
    statLabel: { fontSize: "13px", color: "#6b7280", marginBottom: "8px", fontWeight: "600" },
    statValue: { fontSize: "18px", fontWeight: "700", color: "#111827" },
    signatureBox: { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%", position: "relative", marginTop: "10px" },
    signatureLine: { width: "100%", maxWidth: "320px", height: "2px", background: "linear-gradient(90deg,#9ca3af,#6b7280,#9ca3af)", marginBottom: "12px" },
    signName: { fontSize: "15px", color: "#374151", fontWeight: "700", textAlign: "center", letterSpacing: "0.5px", marginTop: "12px" },
    rightSection: { display: "flex", justifyContent: "center", alignset: "center" },
    singleBadgeCard: (isMobile) => ({ position: "relative", width: isMobile ? "240px" : "380px", display: "flex", justifyContent: "center", alignItems: "center", margin: "0 auto" }),
    singleBadgeImage: { width: "100%", objectFit: "contain", zIndex: 2, filter: "drop-shadow(0 30px 60px rgba(124,58,237,0.35))" },
    badgeGlow: { position: "absolute", width: "280px", height: "280px", background: "radial-gradient(circle, rgba(124,58,237,0.25), transparent)", borderRadius: "50%", zIndex: 1 },
    codematrixstamp: { width: "140px", height: "140px", objectFit: "contain", position: "absolute", left: "50%", top: "5%", transform: "translate(-50%, -50%) ", opacity: 0.82, zIndex: 10, mixBlendMode: "multiply", filter: "contrast(135%) saturate(160%) brightness(0.75) drop-shadow(0 4px 10px rgba(55,0,120,0.18)) blur(0.3px)" },
    footer: (isMobile) => ({ position: "absolute", bottom: 0, left: 0, width: "100%", padding: isMobile ? "12px" : "18px 40px", background: "linear-gradient(90deg,#312e81,#7c3aed,#06b6d4)", display: "flex", flexDirection: isMobile ? "column" : "row", justifyContent: "space-between", alignItems: "center", gap: isMobile ? "6px" : "0px", color: "#fff", fontWeight: "600", fontSize: isMobile ? "11px" : "14px", textAlign: "center" })
};